import Token from '@/utils/Token';

export default {
    permissoes() {
        return axios.get('/api/auth/permissoes', Token.getHeader());
    },
    fasesVisiveis(projetoId) {
        return axios.get(`/api/auth/fases-visiveis/${projetoId}`, Token.getHeader());
    },

    /**
     * Login com Sanctum SPA Authentication.
     * 1. Busca CSRF cookie via /sanctum/csrf-cookie
     * 2. Envia credenciais via POST /api/login
     * O backend detecta automaticamente se e SPA (sessao) ou API (token).
     */
    login(params) {
        return axios.get('/sanctum/csrf-cookie').then(() => {
            return axios.post('/api/login', params);
        });
    },

    logout() {
        return axios.post('/api/logout', {}, Token.getHeader());
    },

    esqueciSenha(params) {
        return axios.post('/api/esqueci-senha', params);
    },

    me() {
        return axios.get('/api/auth', Token.getHeader());
    },

    /**
     * Verifica se a sessao atual e valida.
     * Usado pelo router guard para confirmar autenticacao via cookie.
     */
    check() {
        return axios.get('/api/auth', Token.getHeader());
    },

    profile(params) {
        return axios.post('/api/auth', params, Token.getHeader());
    },
    password(params) {
        return axios.post('/api/auth/password', params, Token.getHeader());
    },
    alterarSenha(params) {
        return axios.post('/api/alterar-senha', params);
    }
}
